
import Vue from 'vue';
import Portal from '../Modal/ModalPortal.vue';
import EButton from '../Button/Button.vue';
import WebText from '../Text/Text.vue';

import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { Padder } from '../Spacings';
import { Row } from '../Grid';
// import { isMobile } from 'mobile-device-detect';

/**
 * > *This component is deprecated, please go to Eucalyptus > NewTray*
 *
 * Tray component.
 *
 * Modal component but show from the bottom to top.
 *
 * There is a `slot` for content of the tray.
 */
export default Vue.extend<any, any, any, any>({
  name: 'Tray',
  components: {
    WebText,
    Portal,
    EButton,
    Padder,
    Row
  },
  props: {
    /**
     * Title of the Tray.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Make title align center.
     */
    centeringTitle: {
      type: Boolean,
      default: true
    },
    /**
     * Open status of the Tray.
     */
    value: {
      type: Boolean,
      default: false
    },
    /**
     * Open status of the Tray.
     */
    active: {
      type: Boolean,
      default: false
    },
    /**
     * Make tray no dragable from the line of top the tray.
     */
    noDrag: {
      type: Boolean,
      default: false
    },
    /**
     * Add **Cancel** button in actions of the Tray.
     */
    twoButtons: {
      type: Boolean,
      default: false
    },
    /**
     * Make button action align row instead column when two button is on.
     */
    rowButtons: {
      type: Boolean,
      default: false
    },
    /**
     * Make button action disappear.
     */
    noButton: {
      type: Boolean,
      default: false
    },
    /**
     * Make content of the tray align center.
     */
    alignCenter: {
      type: Boolean,
      default: false
    },
    /**
     * Showing selection options instead custom template in tray.
     */
    boxContent: {
      type: Boolean,
      default: false
    },
    /**
     * Selection options list.
     */
    products: {
      type: Array,
      default: () => []
    },
    /**
     * The button action text for primary / done button.
     */
    buttonText: {
      type: String,
      default: ''
    },
    /**
     * Border radius of the tray
     */
    radius: {
      type: String,
      default: '0'
    },
    /**
     * The button action text for secondary / cancel button.
     */
    secondaryButtonText: {
      type: String,
      default: ''
    },
    /**
     * Button type of the primary / done button.
     */
    primaryButtonType: {
      type: String,
      default: 'outline-primary'
    },
    /**
     * Button type of the secondary / cancel button.
     */
    secondaryButtonType: {
      type: String,
      default: 'secondary'
    },
    /**
     * Callback when tray is closed.
     */
    onClose: {
      type: Function,
      default: () => {}
    },
    /**
     * Callback when primary / done button clicked.
     */
    onButtonPressed: {
      type: Function,
      default: () => {}
    },
    /**
     * Callback when secondary / cancel button clicked.
     */
    onCloseSecondary: {
      type: Function,
      default: () => {}
    },
    /**
     * Callback when selection option is clicked.
     */
    onValuePressed: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      bottom: '-100vh',
      selectedValue: 0
    };
  },
  computed: {
    computedAlign() {
      if (this.alignCenter && !this.centeringTitle) {
        return `justify-content: center`;
      } else {
        return `justify-content: flex-start`;
      }
    }
  },
  watch: {
    value(next: any, prev: any) {
      if (next !== prev && this.$refs.trayContentRef) {
        if (next) {
          return ((this.$refs.trayContentContainerRef as HTMLElement).style.top = `0`);
        }
        return ((this.$refs.trayContentContainerRef as HTMLElement).style.top = `100vh`);
      }
      return null;
    }
  },
  methods: {
    computedBorder(val: any) {
      if (val === this.selectedValue) {
        return true;
      }
      return false;
    },
    handleSelectBox(val: any, index: any) {
      if (typeof this.onValuePressed === 'function') {
        this.selectedValue = index;
        this.onValuePressed(val);
      }
      /**
       * Handle tray status for open / close
       * @event input
       * @type {function}
       */
      this.$emit('input', this.twoButtons ? true : false);
    },
    handleButtonPressed() {
      if (typeof this.onButtonPressed === 'function') {
        this.onButtonPressed();
      }
      this.$emit('input', false);
    },
    handleClose() {
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
      this.$emit('input', false);
    },
    handleCloseSecondary() {
      if (typeof this.onCloseSecondary === 'function') {
        this.onCloseSecondary();
      }
      this.$emit('input', false);
    },
    // handleDrag(e: DragEvent | TouchEvent) {
    //   let x: number;
    //   let y: number;

    //   if (isMobile) {
    //     const targetTouch = (e as TouchEvent).targetTouches[0];
    //     x = targetTouch.pageX;
    //     y = targetTouch.pageY;
    //   } else {
    //     const { screenX, screenY } = e as DragEvent;
    //     x = screenX;
    //     y = screenY;
    //   }

    //   const contentHeight = (this.$refs.trayContentRef as HTMLElement).scrollHeight;
    //   const top = isMobile ? y - contentHeight : (e as DragEvent).offsetY;

    //   if (!x || !y || top <= 0 || y <= contentHeight) {
    //     return null;
    //   }
    //   return ((this.$refs.trayContentContainerRef as HTMLElement).style.top = `${top}px`);
    // }
    handleDragEnd(e: DragEvent) {
      const contentHeight = (this.$refs.trayContentRef as HTMLElement).offsetHeight;
      const { top } = (this.$refs.trayContentContainerRef as HTMLElement).style;

      const contentTop = Math.abs(Number((top || '').replace(/px/g, '')));

      if (contentTop > contentHeight / 2) {
        if (typeof this.onClose === 'function') {
          this.onClose();
        }
        return this.$emit('input', false);
      }
      return ((this.$refs.trayContentContainerRef as HTMLElement).style.top = `0`);
    }
  }
});
